import React from 'react';
import { Link } from 'react-router-dom';

import arrowRight from '../../../images/arrow-right-blue.svg';

const LearnMore = ({ to = '/nyc/faq', text = 'Learn More' }) => (
  <div className="section-1__links-container">
    <Link className="section-1__link" to={to}>
      {text}
      <span>
        <img
          className="section-1__link__icon"
          src={arrowRight}
          alt="arrow"
        />
      </span>
    </Link>
  </div>
);

export default LearnMore;



// WEBPACK FOOTER //
// ./src/components/Static/LandingPageNYC/LearnMore.js